import { render, staticRenderFns } from "./turntable.vue?vue&type=template&id=87ab3208&scoped=true"
import script from "./turntable.vue?vue&type=script&lang=js"
export * from "./turntable.vue?vue&type=script&lang=js"
import style0 from "./turntable.vue?vue&type=style&index=0&id=87ab3208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ab3208",
  null
  
)

export default component.exports